import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import SlidingPane from 'react-sliding-pane';
import ActionBar from '../layout/ActionBar';
import {
  savePromotion,
  getPromotionById,
  getAudit,
  addAudit,
} from '../../actions/promotionActions';
import { getKeyProviders } from '../../actions/keyProviderActions';
import { getAllTerritories } from '../../actions/territoryActions';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import Loading from '../common/Loading';
import Delete from './slideout/Delete';
import AuditButton from '../audit/components/AuditButton';
import ResponsiveActionBarButtons from '../common/ResponsiveActionBarButtons';
import PromotionForm from './components/PromotionForm';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';

function Promotion() {
  const dispatch = useAppDispatch();
  const keyProviders = useAppSelector((state) => state.keyProviders);
  const territories = useAppSelector((state) => state.territories);
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [, setPageTitle] = usePageTitle(['Promotion']);

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    getValues,
  } = useForm();

  const [promotion, setPromotion] = useState<any>();
  const [deleteSlideoutOpen, setDeleteSlideoutOpen] = useState(false);

  const onSubmit = (data: any) => {
    savePromotion({
      ...promotion,
      ...data,
    }).then(() => {
      toast.success(t('Promotion saved'));
    });
  };

  const handleDelete = (e: React.MouseEvent) => {
    setDeleteSlideoutOpen(true);
    return false;
  };

  useEffect(() => {
    if (id) {
      getPromotionById(id)
        .then((d) => {
          setPromotion(d);
          setPageTitle([d.name, 'Promotion']);
        })
        .catch(() => {
          navigate('/promotions');
          toast.error(t('Promotion not found'));
        });
    } else {
      setPromotion({ id: '' });
    }
    if (!keyProviders) {
      dispatch(getKeyProviders());
    }
    if (!territories) {
      dispatch(getAllTerritories());
    }
  }, [
    id,
    keyProviders,
    territories,
    dispatch,
    setPageTitle,
    navigate,
    t,
  ]);

  return promotion && keyProviders && territories ? (
    <>
      <ActionBar
        breadcrumb={[
          {
            link: '/promotions',
            label: t('Promotion calendar'),
          },
          id
            ? {
                link: `/promotion/${id}`,
                label: promotion.name,
              }
            : {
                label: t('Promition add'),
              },
        ]}
      >
        <div className="d-flex w-100 justify-content-between">
          {id && (
            <AuditButton id={id} getAudit={getAudit} addAudit={addAudit} />
          )}
          <div className="d-flex">
            <ResponsiveActionBarButtons
              buttons={[
                id && (
                  <Button
                    key="delete"
                    className="btn btn-danger ms-2 d-none d-md-inline-flex"
                    onClick={handleDelete}
                    text={t('Delete')}
                  />
                ),
                <Button
                  key="save"
                  text={t('Save')}
                  className="btn btn-primary ms-2"
                  onClick={handleSubmit(onSubmit)}
                />,
              ]}
            />
          </div>
        </div>
      </ActionBar>

      <div className="row">
        <div className="col-sm-12 col-md-12">
          <PromotionForm
            promotion={promotion}
            keyProviders={keyProviders}
            territories={territories}
            register={register}
            errors={errors}
            control={control}
            getValues={getValues}
          />
        </div>
      </div>

      <SlidingPane
        isOpen={deleteSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setDeleteSlideoutOpen(false)}
      >
        <Delete
          id={id}
          done={() => {
            setDeleteSlideoutOpen(false);
            navigate('/promotions/');
          }}
          cancel={() => setDeleteSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  ) : (
    <Loading />
  );
}

export default Promotion;
